import { ref } from "vue";
import { sendGraphQLQuery } from '@/services/gql-util';
import {TransferItem, TransferDestination} from '@/types/Transfer'

export default function useClientTransfer() {
  const transferList = ref<TransferDestination[]>([]); // Adjust type if needed
  const transferSummary = ref<TransferItem[]>([]); // Adjust type if needed
  const loading = ref(false);
  const error = ref<string | null>(null);

  const getClientTransferList = async (vhostId: string): Promise<void> => {
    loading.value = true;
    error.value = null;

    try {
        const query = ` query { Transfers { transferlist(vhost: ${vhostId}) { id name filetype } } } `;
	const data = await sendGraphQLQuery(query, {
		vhost: +vhostId
	});



      transferList.value = data?.Transfers?.transferlist || [];
    } catch (err: any) {
      error.value = err.message || "Failed to fetch data.";
    } finally {
      loading.value = false;
    }
  };
  const getClientTransferSummary = async (vhostId: string): Promise<void> => {
	  loading.value = true;
	  error.value = null;
	  console.log(vhostId);
	  const query= ` query { Transfers { transfersummary(vhost: ${vhostId}) { id title status destination } } } `;
		  try {
			  const data = await sendGraphQLQuery(query, {
				  vhost: +vhostId,
			  });

			  if (data?.Transfers?.transfersummary) {
				  transferSummary.value = [...data.Transfers.transfersummary];
			  } else {
				  console.error('Unexpected response structure:', data);
				  transferSummary.value = [];
			  }
		  } catch (error) {
			  console.error('Error fetching transfers:', error);
			  transferSummary.value = [];
			  throw error;
		  }

	  };


  return { transferSummary, getClientTransferSummary,transferList, getClientTransferList, loading, error };
}

